import { useEffect, useState, useMemo } from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import {
  Box,
  Button,
  Flex,
  Select,
} from "@chakra-ui/react";
import Pagination from "../order/components/pagination";
import dateFormat from "dateformat";
import DataTable from "react-data-table-component";
import Breadcrumb from "../common/breadcrumb";
import navguard from "../auth/navguard";
import Axios from "../../services/axios";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import queryString from "query-string";
import { DownloadIcon } from "../../assets/icons/DownloadIcon";
import DownloadCommissionDetail from "./components/DownloadCommissionDetail";
import { resellerLevelList } from "../../constants/helpers/resellerLevelList";
import { capitalize } from "../helpers/string";

const DetailCommission = () => {
  const formatter = new Intl.NumberFormat("id-ID");
  const [page, setPage] = useState(0);
  const [responseTableCommission, setResponseTableCommission] = useState([]);
  const [filterReseller, setFilterReseller] = useState("All");
  const { id } = useParams();
  const history = useHistory();
  const changePageHandler = (value) => {
    setPage(value.selected);
  };
  const { search } = useLocation();
  const [totalPage, setTotalPage] = useState(0);
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { periodStart, periodEnd } = queryParams;

  useEffect(() => {
    if (!periodStart || !periodEnd) {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      
      const defaultPeriodStart = dateFormat(firstDayOfMonth, "yyyy-mm-dd");
      const defaultPeriodEnd = dateFormat(today, "yyyy-mm-dd");

      const updatedParams = {
        ...queryParams,
        periodStart: defaultPeriodStart,
        periodEnd: defaultPeriodEnd,
      };

      const newSearch = queryString.stringify(updatedParams);
      history.replace({ search: newSearch });
    }
  }, []);

  const fetchDataDetail = async (id) => {
    try {
      const { data } = await Axios({
        url: `/admin/commission/detail/${id}${search}`,
        params: {
          limit: 10,
          page: +page + 1,
          ...(filterReseller !== "All" && { resellerStatus: filterReseller }),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });

      const meta = {...data?.data};
      delete meta.users;
      setTotalPage(meta.totalPage);

      setResponseTableCommission(
        data?.data?.users?.map?.(user => ({
          ...user,
          resellerId: user.id,
          resellerName: user.name,
        })) || []
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (periodStart && periodEnd) {
      fetchDataDetail(id);
    }
  }, [id, search, page, filterReseller]);

  const columns = [
    {
      name: <span style={{ color: "#fff" }}>Community Code</span>,
      cell: (row) => {
        return <span>{row.communityCode}</span>;
      },
      sortable: false,
    },
    {
      name: <span style={{ color: "#fff" }}>Community Name</span>,
      cell: (row) => {
        return <span>{row.communityName}</span>;
      },
      sortable: false,
    },
    {
      name: (
        <div style={{ 
          position: "relative",
          width: "100%",
          color: "#fff"
        }}>
          <div style={{
            position: "absolute",
            left: "-16px",
            top: "-19px",
            bottom: "-20px",
            borderLeft: "1px solid #fff"
          }} />
          Reseller ID
        </div>
      ),
      selector: "resellerId",
      cell: (row) => {
        return <span>{row.resellerId}</span>;
      },
      sortable: false,
    },
    {
      name: <span style={{ color: "#fff" }}>Reseller Name</span>,
      cell: (row) => {
        return <span>{row.resellerName}</span>;
      },
      sortable: false,
    },
    {
      name: <span style={{ color: "#fff" }}>Total Order</span>,
      cell: (row) => {
        return <span>Rp{formatter.format(row.totalOrder)}</span>;
      },
      sortable: false,
    },
    {
      name: <span style={{ color: "#fff" }}>Last Order Date</span>,
      cell: (row) => {
        return <span>{!!row.lastOrderDate ? dateFormat(row.lastOrderDate, "dd / mm / yyyy") : "-"}</span>;
      },
      sortable: false,
    },
  ];

  return (
    <>
      <Container fluid={true} style={{ paddingTop: "24px" }}>
        <Card>
          <CardHeader>
            <Breadcrumb isStack title={"Detail Commission"} parent={{label: "Commission", path: "/commission/list-commission"}} />
            <Flex justifyContent="space-between" alignItems="center">
              <Box>
                <Select
                  width="200px"
                  value={filterReseller}
                  onChange={(event) => {
                    setFilterReseller(event.target.value);
                    setPage(0);
                  }}
                >
                  <option value="All">All</option>
                  {
                    resellerLevelList.map((level) => (
                      <option value={level}>{capitalize(level)}</option>
                    ))
                  }
                </Select>
              </Box>
              <DownloadCommissionDetail
                id={id}
                periodStart={periodStart}
                periodEnd={periodEnd}
                resellerStatus={filterReseller !== "All" ? filterReseller : null}
                Trigger={({ onClick }) => (
                  <Button 
                    leftIcon={<DownloadIcon />} 
                    fontWeight="400" 
                    backgroundColor="#fff" 
                    border="1px solid #E2E8F0" 
                    color="#1A202C"
                    onClick={onClick}
                  >
                    Download
                  </Button>
                )}
              />
            </Flex>
          </CardHeader>
          <CardBody style={{ paddingTop: 0 }}>
            <DataTable
              noHeader={true}
              data={responseTableCommission}
              columns={columns}
              center={true}
              customStyles={{
                headCells: {
                  style: {
                    backgroundColor: "#ff8084",
                    color: "#fff",
                    fontWeight: "400",
                    fontSize: "14px",
                  },
                },
              }}
            />
            {!isEmpty(responseTableCommission) && (
              <Box margin={"2rem 0"}>
                <Pagination
                  page={page}
                  totalPage={totalPage}
                  changePageHandler={changePageHandler}
                />
              </Box>
            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default navguard(DetailCommission);
